import { useNavigate } from "react-router-dom";

export default function useUpgrade() {
  const navigate = useNavigate();
  const upgrade = () => {
    navigate("/go-premium");
  };

  return upgrade;
}
